<template>
  <div id="invitation_share">
    <van-row>
      <van-col span="24" class="invitation_share">
        <van-col span="20" offset="2" class="invitation_share_name">{{ $t('column.download_registration') }}</van-col>
        <van-col span="20" offset="2" class="invitation_share_title">{{ title }}</van-col>
        <van-col span="20" offset="2" class="invitation_share_qrcode">
          <div class="invitation_share_qrcode_bottom">
            <div class="qrcode" ref="qrCodeUrl"></div>
          </div>
        </van-col>
        <van-col span="20" offset="2" class="invitation_share_btn" @click="invitation_share_btn">{{ $t('btn.share')}}</van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import QRCode from 'qrcodejs2'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  export default {
    data() {
      return {
        url: '',
        title: ''
      }
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.invitation_share')
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.mobile_intercept = this.mobile_intercept
    },
    methods: {
      creatQrCode() {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: this.url, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      invitation_share_btn () {
        // 分享拦截
        this.mobile_intercept(this.url)
      },
      mobile_intercept(url) {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.distribution_share.postMessage(url)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.distribution_share(url)
        }
      },
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=invite_share", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          if(res.data.status != 1){
            Toast(res.data.error);
          }
          this.title = res.data.data.title
          this.url = res.data.data.url
          this.creatQrCode()
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_share.vue